import Vue from "vue"
import FeatherIcon from "@core/components/feather-icon/FeatherIcon.vue"
import PeopleCreateModal from "@/views/app/people/people-create/PeopleCreate.vue"
import CompaniesCreateModal from "@/views/app/companies/companies-create/CompaniesCreate.vue"

Vue.component(FeatherIcon.name, FeatherIcon)
Vue.component(PeopleCreateModal.name, PeopleCreateModal)
Vue.component(CompaniesCreateModal.name, CompaniesCreateModal)
